import React from 'react';
import './App.css';

function App() {
  return (
    <div className='app'>
      <a href='/input'>
        <button type='button' className='btn btn-primary send'>
          Send
        </button>
      </a>
      <a href='/receive'>
        <button type='button' className='btn btn-secondary send'>
          Receive
        </button>
      </a>
    </div>
  );
}

export default App;
